import React, { createContext, useContext, useState, useEffect } from 'react';

export interface TemporalState {
  currentTime: Date;
  windowSec: number;    // fixed 24h window for M2 (86400s)
  setCurrentTime: (t: Date) => void;
}

const DEFAULT_STATE: TemporalState = {
  currentTime: new Date(),
  windowSec: 86400,
  setCurrentTime: () => {},
};

export const TemporalContext = createContext<TemporalState>(DEFAULT_STATE);

export function TemporalProvider({ children }: { children: React.ReactNode }) {
  const [currentTime, setCurrentTime] = useState<Date>(new Date());
  const windowSec = 86400;

  useEffect(() => {
    const r = (window as any)._scRenderer;
    if (!r || typeof r.setTemporalRange !== 'function') return;
    const endSec   = currentTime.getTime() / 1000;
    const startSec = endSec - windowSec;
    try {
      r.setTemporalRange(startSec, endSec);
    } catch (e) {
      console.warn('[TemporalController] setTemporalRange failed:', e);
    }
  }, [currentTime, windowSec]);

  return (
    <TemporalContext.Provider value={{ currentTime, windowSec, setCurrentTime }}>
      {children}
    </TemporalContext.Provider>
  );
}

export function useTemporalContext(): TemporalState {
  return useContext(TemporalContext);
}
